export default {
      id: "arrows-left-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#arrows-left-usage",
      toString: function () {
        return this.url;
      }
    }